import { Pipe, PipeTransform } from '@angular/core';
import { ContainerService } from '../../common/_services/container.service';

@Pipe({
  name: 'datacontainer',
  pure: true,
  standalone: false,
})
export class DatacontainerPipe implements PipeTransform {
  constructor(private containerService: ContainerService) {}

  transform(value: any, type?: string): any {
    if (!value || value === undefined) {
      return null;
    }

    if (!type || type === undefined) {
      const selected = this.containerService.getLocalContainerById(Number(value));
      if (selected) {
        return selected;
      } else {
        return null;
      }
    } else {
      const selected = this.containerService.getLocalContainerByName(String(value));
      if (selected) {
        return selected;
      } else {
        return null;
      }
    }
  }
}
